export enum ServiceCenterEnum {
    /**Лантер */
    lanter = 13
}